{{custom-wizard-date-input
  date=this.date
  onChange=(action "onChange")
  tabindex=this.field.tabindex
  format=this.field.format
}}